import type { HTMLProps } from 'react';
import type { Control } from 'react-hook-form';

import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Field, Input } from '~/components/Form';

type FormWithAddressNumber = { address: { number: string } };

export const FormAddressNumber = <T extends FormWithAddressNumber>({
  control,
  ...props
}: HTMLProps<HTMLDivElement> & {
  control: T extends FormWithAddressNumber ? Control<T> : never;
}) => {
  const { t } = useTranslation(['clients', 'validation']);

  return (
    <div {...props}>
      <Controller
        control={control as Control<FormWithAddressNumber>}
        name="address.number"
        render={({ field: { name, onBlur, onChange, ref, value }, fieldState: { error, invalid, isDirty, isTouched } }) => (
          <Field.Root dirty={isDirty} invalid={invalid} name={name} touched={isTouched}>
            <Field.Label>{t('clients:fields.number.label')}</Field.Label>

            <Input onBlur={onBlur} onValueChange={onChange} ref={ref} value={value} />

            <Field.Error match={!!error}>{error?.message}</Field.Error>
          </Field.Root>
        )}
        rules={{
          required: { value: true, message: t('validation:required') },
          validate: (value) => !!value.trim() || t('validation:required'),
        }}
      />
    </div>
  );
};
